const React = require('react');
const getTime = require('mn-utils/time');
const {
  getRFC3339,
  normalizeDate,
} = require('mn-utils/formatTime');
const formatTime = require('../../../../utils/formatTime');
const formatNumCoin = require('../../../../utils/formatNumCoin');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const Tooltip = require('../../../dumb/Tooltip/A');
const ButtonUp = require('../../../dumb/Button/Up');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');

const EXPIRED_LIMIT = 300;


module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/exchangeRates')
      .apiAdminExchangeRatesList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const time = normalizeDate(data.updated_at);
      const timeDifference = (getTime() - time.getTime()) * 0.001;
      const hasExpired = timeDifference > EXPIRED_LIMIT;
      const rate = data.rate;
      return (
        <RowA className={`cF99.expired>1` + (hasExpired ? ' expired' : '')}>
          <ColA className="w(|min)100">
            <Tooltip>{data.base}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.quote}</Tooltip>
          </ColA>
          <ColA className="w(|min)170">
            <Tooltip
              title={getRFC3339(time)}
            >{formatTime(time)}</Tooltip>
          </ColA>
          <ColA className="w(|min)170">
            <Tooltip>{data.exchange_type}</Tooltip>
          </ColA>
          <ColA className="wmin0 fx1">
            <Tooltip>{data.exchange_name}</Tooltip>
          </ColA>
          <ColA className="w(|min)150">
            <Tooltip
              title={rate}
            >{formatNumCoin(rate)}</Tooltip>
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Exchange rates</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="rlv h wmin800">
                <div>
                  <RowB>
                    <ColB className="w(|min)100">Base</ColB>
                    <ColB className="w(|min)100">Quote</ColB>
                    <ColB className="w(|min)170">Date & Time</ColB>
                    <ColB className="w(|min)170">Exchange type</ColB>
                    <ColB className="wmin0 fx1">Exchange name</ColB>
                    <ColB className="w(|min)150">Rate</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
